module.exports = __webpack_public_path__ + "img/valueResult.e9a33859.png";